import { render, staticRenderFns } from "./DurationRingView.vue?vue&type=template&id=2bd26bb6&scoped=true&"
import script from "./DurationRingView.vue?vue&type=script&lang=js&"
export * from "./DurationRingView.vue?vue&type=script&lang=js&"
import style0 from "./DurationRingView.vue?vue&type=style&index=0&id=2bd26bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd26bb6",
  null
  
)

export default component.exports